import { observable, action, computed } from 'mobx';
import { UnitDistance } from '../../../api/Interfaces';
import { IFilters } from '../entities/StoresFilter';

export interface IConfig {
    stores: {
        isCallForPlaceOrderEnabled: boolean;
    };
    googleApiKey: string;
    mapRegion: string;
    mapLanguage: string;
    siteUrl: string;
    routes: {
        stores: string;
    };
    storesDefaultSearchLocation: {
        lat: number;
        lng: number;
    };
    storesSearchRadius: number;
    storesUnitDistance: keyof typeof UnitDistance;
    storesSearchCount: number;
    oabStoresSearchCount: number;
    currency: string;
    bopisEnabled: boolean;
    fullAddressSearchEnabled: boolean;
    bopisDropoffOffset: number;
    postmatesCutoffTimeOffset: number;
    postmatesMaxDeliveryDistance: number;
    postmatesDropoffOffsetAsap: number;
    postmatesDropoffOffsetNotAsap: number;
    postmatesPickupOffset: number;
    courierEnabled: boolean;
    bopisRadius: number; // In miles
    forceBopisVisibility: boolean;
    extractZipcodeRegexp: string;
    coloredMap: boolean;
    isOAB: boolean;
    domainLangPrefix: string;
    fis: {
        enable: boolean;
    };
    featureFlags: {
        showOabServices: boolean;
        showEvents: boolean;
        storeDirectoryIsLanding: boolean;
        disableAddressLink: boolean;
        disableDistance: boolean;
        disableGetDirections: boolean;
        disableLocationPop: boolean;
        disableStaticMap: boolean;
        enableFilters: boolean;
        openNow: boolean;
        mapEnabled: boolean;
        enableStoreDetailsLink: boolean;
        enableMapTab: boolean;
    };
    filters: IFilters;
    oabSelectedStoreId: number;
    oabSelectedCounterId: number;
    home_path: string;
    formatting: {
        address_format: {
            order: string[];
            separator: string;
        };
    };
    inStorePickupBannerNodeId: number;
    showState: boolean;
    apptBookingServicesNodeId: number;
}
export class Config {
    @observable public config: IConfig;

    @computed
    get inStorePickupBannerNodeId() {
        return this.config.inStorePickupBannerNodeId;
    }

    @computed
    get inStoreServicesNodeId() {
        return this.config.apptBookingServicesNodeId;
    }
    @action
    public updateConfig(config: Partial<IConfig>) {
        this.config = { ...this.config, ...config };
    }
}
